<app-subject-form
  [currentAddressFormGroup]="addressFormGroup" [subjectFormGroup]="subjectFormGroup"
  (back)="back.emit()" (submittedData)="submittedData.emit($event)">
</app-subject-form>
